import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { OfferBundlePreview } from "../../../models/offer-bundle-preview.model";
import { OfferProductIds } from "../../../models/offer-action-ids.model";
import { PaymentFrequencyLabel } from "../../../../application/application.model";
import { compareOfferTabs } from "../../../models/offer-bundle-grouping";
import { getOfferTermLabel } from "../../../pipes/offer-term-label-pipe";

interface OfferRepaymentTab {
  offerBundle: OfferBundlePreview;
  term: string;
  paymentFrequency: string;
}

@Component({
    selector: "ifc-offer-repayment-navigation",
    templateUrl: "./offer-repayment-navigation.component.html",
    styleUrls: ["./offer-repayment-navigation.component.scss"],
    standalone: false
})
export class OfferRepaymentNavigationComponent implements OnChanges {
  @Input() offerBundles: OfferBundlePreview[];
  @Input() currentOfferBundle: OfferBundlePreview;

  @Output()
  changeOffer = new EventEmitter<OfferProductIds>();

  tabs: OfferRepaymentTab[];

  ngOnChanges(): void {
    this.tabs = [...(this.offerBundles ?? [])]
      .sort(compareOfferTabs)
      .map((offerBundle) => ({
        offerBundle,
        term: `${offerBundle.express ? "express " : ""}${getOfferTermLabel(Number(offerBundle.repayment))}`,
        paymentFrequency: PaymentFrequencyLabel.get(offerBundle.paymentFrequency),
      }));
  }

  click(offerBundle: OfferBundlePreview) {
    const data: OfferProductIds = {
      offerId: offerBundle.offerBundleId,
      productCode: offerBundle.productCode,
    };
    this.changeOffer.emit(data);
  }

  trackByBundleId(_index: number, tab: OfferRepaymentTab): number {
    return tab.offerBundle.offerBundleId;
  }
}
